import React from "react";
import { postData } from "../../../../../api/componentAPIs";
import CustomConfirmationDialog from "../../../Dispatch/RouteExecution/DriverPopUp/common/CustomConfirmationDialog";

function DeleteDialog(props) {
  const deleteTerminal = () => {
    const requestParams = {
      terminalCode: props.selectedTerminal,
      feederTerminals: [],
    };
    postData("UpdateFeederTerminal", requestParams).then(
      (response) => {
        if (response && Math.trunc(response.status / 100) === 2) {
          props.enqueueSnackbar(`Deleted terminal ${props.selectedTerminal} `, {
            variant: "success",
          });
          props.loadFeederTerminalsData();
        } else {
          props.enqueueSnackbar(
            `Error deleting terminal ${props.selectedTerminal} `,
            { variant: "error" }
          );
        }
        props.closeDeleteTerminalDialog();
      },
      (_error) => {
        this.props.enqueueSnackbar(
          `Error deleting terminal ${props.selectedTerminal} `,
          {
            variant: "error",
          }
        );
        props.closeDeleteTerminalDialog();
      }
    );
  };

  return (
    <CustomConfirmationDialog
      title="Remove feeder terminal"
      cancelButtonLabel="Cancel"
      confirmButtonLabel="Remove"
      mode="danger"
      onConfirm={deleteTerminal}
      onCancel={props.closeDeleteTerminalDialog}
    >
      Are you sure you want to remove terminal {props.selectedTerminal} from
      Feeder terminals list?
    </CustomConfirmationDialog>
  );
}

export default DeleteDialog;
